import { useState } from "react";
import MessagingRateModal from "./settings-modal";


export default function MessagingRatePage() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="p-8 bg-gray-50 min-h-screen flex items-center justify-center">
      <div className="bg-white shadow-lg rounded-xl p-6 w-full max-w-md">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">
          Messaging Rate Configuration
        </h2>

        <p className="text-sm text-gray-600 mb-6">
          Set the messaging rates for your platform. Click the button below to
          begin.
        </p>

        <button
          onClick={() => setIsModalOpen(true)}
          className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition-colors flex items-center justify-center gap-2 w-full"
        >
          <span className="text-xl font-bold">₦</span>
          <span>Set Messaging Rates</span>
        </button>

        <MessagingRateModal 
          isOpen={isModalOpen} 
          setIsOpen={setIsModalOpen} 
        />
      </div>
    </div>
  );
}